export type DetentionLumperStatus = 0 | 1 | 2; // 0=Pending, 1=Paid, 2=Canceled

export const DetentionLumperStatusLabel: Record<DetentionLumperStatus, string> = {
  0: "Pending",
  1: "Paid",
  2: "Canceled",
};

// 0=Every 24 hours, 1=Every 48 hours, 2=Every 72 hours, 3=Once a week
export type BrokerEmailReminderFrequency = 0 | 1 | 2 | 3;

export const BrokerEmailReminderFrequencyLabel: Record<BrokerEmailReminderFrequency, string> = {
  0: "Every 24 hours",
  1: "Every 48 hours",
  2: "Every 72 hours",
  3: "Once a week",
};

export interface Lumper {
  id: number;
  loadNumber: string;
  brokerEmail: string;
  vehicleId: number;
  vehicleName?: string;
  trailerId: number;
  trailerUnit?: string;
  amount?: number;
  requestTime: string;
  notes?: string;
  status: DetentionLumperStatus;
  emailSent: boolean;
  emailReminderFrequency: BrokerEmailReminderFrequency;
  lastReminderEmailSentAt?: string;
  documentUrl?: string;
  documentFileName?: string;
  createdAt: string;
  updatedAt?: string;
}

export interface CreateLumperDto {
  loadNumber: string;
  brokerEmail: string;
  vehicleId: number;
  trailerId: number;
  amount?: number;
  notes?: string;
  sendEmailToBroker?: boolean;
  emailReminderFrequency?: BrokerEmailReminderFrequency;
}

export interface UpdateLumperDto {
  loadNumber?: string;
  brokerEmail?: string;
  vehicleId?: number;
  trailerId?: number;
  amount?: number;
  notes?: string;
  status?: DetentionLumperStatus;
  sendEmailToBroker?: boolean;
  emailReminderFrequency?: BrokerEmailReminderFrequency;
}
